import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import StyleGroup from "../../../../viewer/chart/StyleGroup.tsx";
import { selectChartSettingsState } from "../../../../../store/selectors/fieldsStateSelectors.ts";
import GridModeItem from "./GridModeItem.tsx";
import RotateItem from "./RotateItem.tsx";
import ThicknessItem from "./ThicknessItem.tsx";
import ToolTipItem from "./ToolTipItem.tsx";

export default function ChartStyles({ readonlyMode }: { readonlyMode: boolean }) {
  const settingsAreaValues = useSelector(selectChartSettingsState);

  return (
    <StyleGroup caption="General">
      <Stack spacing={1} useFlexGap sx={{ width: "100%" }}>
        <GridModeItem settings={settingsAreaValues} readonlyMode={readonlyMode} />
        <RotateItem settings={settingsAreaValues} readonlyMode={readonlyMode} />
        <ThicknessItem settings={settingsAreaValues} readonlyMode={readonlyMode} />
        <ToolTipItem settings={settingsAreaValues} readonlyMode={readonlyMode} />
      </Stack>
    </StyleGroup>
  );
}
